import { styled } from "@mui/system";
import { MenuItem as MuiMenuItem } from "@mui/material";

const MenuItem = styled(MuiMenuItem)(({ styles }) => ({
  "&.MuiMenuItem-root": {
    color: "var(--text-primary)",
    backgroundColor: "var(--container-light)",
  },

  "&.Mui-selected": {
    backgroundColor: "var(--container-extralight)",
  },

  "&:hover": {
    backgroundColor: "var(--container-extralight)",
    "&.Mui-selected": {
      backgroundColor: "var(--container-extralight)",
    },
  },

  ...styles,
}));

export default MenuItem;
